import { type SxProps, type Theme, toggleButtonClasses } from "@mui/material";

// custom styles & overrides for the already-existing MuiToggleButtonGroup override in the main theme.ts file
export const TOGGLE_GROUP_SX = {
  gap: 1,
  background: "none",

  [`& .${toggleButtonClasses.root}`]: {
    padding: 1,
  },
  [`& .${toggleButtonClasses.selected}`]: {
    boxShadow: "none !important",
    bgcolor: (theme: Theme) =>
      `${(theme.vars || theme).palette.action.selected} !important`,
    pointerEvents: "auto !important",
  },
} as SxProps;
